import {ManagedModelType} from 'models/ManagedModelDefinitions';
import AllModelManager from 'models/managers/AllModelManager';
import {getStore} from 'redux-stores/Store';

import {WorkflowSelector} from './reduceWorkflows';
import {WorkflowTemplate} from './WorkflowConstants';
import * as WorkflowTemplateActions from './WorkflowTemplateActions';

export default class AllWorkflowTemplatesModelManager extends AllModelManager<ManagedModelType.ALL_WORKFLOW_TEMPLATES> {
  constructor() {
    super(ManagedModelType.ALL_WORKFLOW_TEMPLATES);
  }

  async doFetchAll(): Promise<void> {
    await WorkflowTemplateActions.fetchAllWorkflowTemplates();
  }

  getAll(): Array<WorkflowTemplate> | null {
    const selector = new WorkflowSelector(getStore().getState().models.workflows);
    return selector.getAllWorkflowTemplates();
  }
}
